// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"485":"bc09b0f4","940":"5181de74"}[chunkId] + ".chunk.js";
};